// extracted by mini-css-extract-plugin
module.exports = {"katexText":"KatexText_katexText__3QASO"};